import { useBlockProps, InnerBlocks } from "@wordpress/block-editor";
import CompareTableLayout from "./components/CompareTableLayout";
import LoadingSkeleton from "./components/LoadingSkeleton";
import classNames from "classnames";

export default function Save({ attributes }) {
  const { isPopup, compareFields } = attributes;

  const blockProps = useBlockProps.save({
    "data-compare-fields": compareFields.join(","),
    className: classNames("", {
      "brandy-compare-show-image": compareFields.includes("image"),
      "brandy-compare-show-description": compareFields.includes("description"),
      "brandy-compare-show-price": compareFields.includes("price"),
      "brandy-compare-show-rating": compareFields.includes("rating"),
      "brandy-compare-show-add-to-cart": compareFields.includes("add_to_cart"),
    }),
  });

  return (
    <div {...blockProps}>
      {isPopup && <InnerBlocks.Content />}
      <div
        className={`compare-table-wrapper ${
          isPopup ? "is-popup" : "is-inline"
        }`}
      >
        <LoadingSkeleton compareFields={compareFields} />
        <CompareTableLayout />
      </div>
    </div>
  );
}
